<template>
    <div>
        <ul
            v-if="tasksToShow.length > 0"
            class="task-list"
        >
            <li
                v-for="task in tasksToShow"
                :key="task.taskId"
            >
                <task-list-item
                    :task="task"
                    class="task-list-item"
                    @click-on-show-graph-icon="clickOnShowDrawIcon"
                    @click-on-show-detailed-task-info-icon="clickOnShowDetailedTaskInfoIcon"
                />
            </li>
        </ul>
    </div>
</template>

<script>
import TaskListItem from './TaskListItem'
import moment from 'moment'

export default {
  name: 'TaskList',
  components: {
    TaskListItem
  },
  props: {
    tasks: {
      type: Array,
      required: true
    },
    limitOutput: {
      type: Number,
      required: false
    }
  },
  computed: {
    tasksToShow() {
      const arrToSort = [...this.tasks]
      const sorted = arrToSort.sort((one, other) => {
        const oneStartDate = moment(one.addedAt)
        const otherStartDate = moment(other.addedAt)
        const oneGoesFirst = -1
        const otherGoesFirst = 1

        if (oneStartDate.isAfter(otherStartDate)) {
          return oneGoesFirst
        } else {
          return otherGoesFirst
        }
      })

      return this.limitOutput !== undefined ? sorted.slice(0, this.limitOutput) : sorted
    }
  },
  methods: {
    clickOnShowDrawIcon(payload) {
      this.$emit('click-on-show-graph-icon', payload)
    },
    clickOnShowDetailedTaskInfoIcon(task) {
      this.$emit('click-on-show-detailed-task-info-icon', task)
    },
  }
}
</script>

<style lang="sass" scoped>
    .task-list
        list-style: none
        padding: 0
        margin: 0

    .task-list-item
        margin-bottom: gridSteps(3)
</style>
